import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const Notification = () => {

  const [toastVisible, setToastVisible] = useState<boolean>(false);

  useEffect(() => {
    let toastTimer: any;

    if (toastVisible) {
      toastTimer = setTimeout(() => setToastVisible(false), 3000);
    }

    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastVisible]);

  // notification open
  const [toastOpen, setToastOpen] = useState<boolean>(false);

  const toggleToast = () => {
    setToastOpen(!toastOpen);
  };

  // Position Notification
  const [toast1, setToast1] = useState<boolean>(false);
  const [toast2, setToast2] = useState<boolean>(false);
  const [toast3, setToast3] = useState<boolean>(false);
  const [toast4, setToast4] = useState<boolean>(false);
  const [toast5, setToast5] = useState<boolean>(false);
  const [toast6, setToast6] = useState<boolean>(false);

  useEffect(() => {
    let toastTimer: any;
    if (toast1) {
      toastTimer = setTimeout(() => setToast1(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toast1]);

  useEffect(() => {
    let toastTimer: any;
    if (toast2) {
      toastTimer = setTimeout(() => setToast2(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toast2]);
  useEffect(() => {
    let toastTimer: any;
    if (toast3) {
      toastTimer = setTimeout(() => setToast3(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toast3]);
  useEffect(() => {
    let toastTimer: any;
    if (toast4) {
      toastTimer = setTimeout(() => setToast4(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toast4]);
  useEffect(() => {
    let toastTimer: any;
    if (toast5) {
      toastTimer = setTimeout(() => setToast5(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toast5]);
  useEffect(() => {
    let toastTimer: any;
    if (toast6) {
      toastTimer = setTimeout(() => setToast6(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toast6]);

  //   Notification Color
  const [toastPri, setToastPri] = useState<boolean>(false);
  const [toastInfo, setToastInfo] = useState<boolean>(false);
  const [toastSuc, setToastSuc] = useState<boolean>(false);
  const [toastWar, setToastWar] = useState<boolean>(false);
  const [toastDan, setToastDan] = useState<boolean>(false);
  const [toastDark, setToastDark] = useState<boolean>(false);
  const [toastSec, setToastSec] = useState<boolean>(false);
  const [toastLight, setToastLight] = useState<boolean>(false);

  useEffect(() => {
    let toastTimer: any;
    if (toastPri) {
      toastTimer = setTimeout(() => setToastPri(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastPri]);

  useEffect(() => {
    let toastTimer: any;
    if (toastInfo) {
      toastTimer = setTimeout(() => setToastInfo(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastInfo]);
  useEffect(() => {
    let toastTimer: any;
    if (toastSuc) {
      toastTimer = setTimeout(() => setToastSuc(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastSuc]);
  useEffect(() => {
    let toastTimer: any;
    if (toastWar) {
      toastTimer = setTimeout(() => setToastWar(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastWar]);
  useEffect(() => {
    let toastTimer: any;
    if (toastDan) {
      toastTimer = setTimeout(() => setToastDan(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastDan]);
  useEffect(() => {
    let toastTimer: any;
    if (toastDark) {
      toastTimer = setTimeout(() => setToastDark(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastDark]);
  useEffect(() => {
    let toastTimer: any;
    if (toastSec) {
      toastTimer = setTimeout(() => setToastSec(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastSec]);
  useEffect(() => {
    let toastTimer: any;
    if (toastLight) {
      toastTimer = setTimeout(() => setToastLight(false), 3000);
    }
    return () => {
      clearTimeout(toastTimer);
    };
  }, [toastLight]);

  return (
    <React.Fragment>
      <BreadCrumb title="Notification" pageType="Components" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {/* Basic Notification */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Notification
            </h2>
            <div className="relative">
              {toastVisible && (
                <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 rtl:left-5 ltr:right-5 z-[99999] opacity-100 transition-all ease-out duration-300">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
              <button
                className="btn bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                onClick={() => setToastVisible(!toastVisible)}
              >
                Open Notification
              </button>
            </div>
          </div>

          {/* Notification With Close */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Notification With Close
            </h2>
            <div>
              <button
                onClick={toggleToast}
                className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
              >
                Click Me!
              </button>
              {toastOpen && (
                <div
                  x-show="notificationOpen"
                  className="bg-black flex items-start gap-3 text-white py-3 px-4 rounded-md max-w-[250px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]"
                >
                  <span>Hello, world! This is a toast message.</span>
                  <button type="button" onClick={toggleToast} className="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Position Notification */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Position Notification
            </h2>
            <div className="flex flex-wrap items-center gap-4">
              <div>
                {toast1 && (
                  <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] fixed top-5 ltr:left-5 rtl:right-5 z-[99999]">
                    <span>Hello, world! This is a toast message.</span>
                  </div>
                )}
                <button
                  className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
                  onClick={() => setToast1(!toast1)}
                >
                  Top Left
                </button>
              </div>
              <div>
                {toast2 && (
                  <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] mx-auto fixed top-5 left-0 right-0 z-[99999]">
                    <span>Hello, world! This is a toast message.</span>
                  </div>
                )}
                <button
                  className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
                  onClick={() => setToast2(!toast2)}
                >
                  Top Center
                </button>
              </div>
              <div>
                {toast3 && (
                  <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] fixed top-5 ltr:right-5 rtl:left-5 z-[99999]">
                    <span>Hello, world! This is a toast message.</span>
                  </div>
                )}
                <button
                  className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
                  onClick={() => setToast3(!toast3)}
                >
                  Top Right
                </button>
              </div>
              <div>
                {toast4 && (
                  <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                    <span>Hello, world! This is a toast message.</span>
                  </div>
                )}
                <button
                  className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
                  onClick={() => setToast4(!toast4)}
                >
                  Bottom Right
                </button>
              </div>
              <div>
                {toast5 && (
                  <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] mx-auto fixed bottom-5 right-0 left-0 z-[99999]">
                    <span>Hello, world! This is a toast message.</span>
                  </div>
                )}
                <button
                  className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
                  onClick={() => setToast5(!toast5)}
                >
                  Bottom Center
                </button>
              </div>
              <div>
                {toast5 && (
                  <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:left-5 rtl:right-5 z-[99999]">
                    <span>Hello, world! This is a toast message.</span>
                  </div>
                )}
                <button
                  className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black"
                  onClick={() => setToast6(!toast6)}
                >
                  Bottom Left
                </button>
              </div>
            </div>
          </div>

          {/* Notification Color */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Notification Color
            </h2>
            <div className="flex flex-wrap items-center gap-4">
              <div>
              {toastPri && (
                <div className="bg-purple text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="transition-all duration-300 border rounded-md btn text-purple border-purple hover:bg-purple hover:text-white" onClick={() => setToastPri(!toastPri)}>
                  Primary
                </button>
              </div>
              <div>
              {toastInfo && (
                <div className="bg-info text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="transition-all duration-300 border rounded-md btn text-info border-info hover:bg-info hover:text-white" onClick={() => setToastInfo(!toastInfo)}>
                  Info
                </button>
              </div>
              <div>
              {toastSuc && (
                <div className="bg-success text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="transition-all duration-300 border rounded-md btn text-success border-success hover:bg-success hover:text-white" onClick={() => setToastSuc(!toastSuc)}>
                  Success
                </button>
              </div>
              <div>
              {toastWar && (
                <div className="bg-warning text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="transition-all duration-300 border rounded-md btn text-warning border-warning hover:bg-warning hover:text-white" onClick={() => setToastWar(!toastWar)}>
                  Warning
                </button>
              </div>
              <div>
              {toastDan && (
                <div className="bg-danger text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="transition-all duration-300 border rounded-md btn text-danger border-danger hover:bg-danger hover:text-white" onClick={() => setToastDan(!toastDan)}>
                  danger
                </button>
              </div>
              <div>
              {toastDark && (
                <div className="bg-black text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="text-black transition-all duration-300 border border-black rounded-md btn dark:text-white dark:hover:text-white dark:border-darkborder dark:hover:border-black hover:bg-black hover:text-white" onClick={() => setToastDark(!toastDark)}>
                  black
                </button>
              </div>
              <div>
              {toastSec && (
                <div className="bg-muted text-white py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="transition-all duration-300 border rounded-md btn text-muted border-muted dark:border-darkmuted dark:text-darkmuted dark:hover:text-white hover:bg-muted hover:text-white" onClick={() => setToastSec(!toastSec)}>
                  Secondary
                </button>
              </div>
              <div>
              {toastLight && (
                <div className="bg-light text-black py-3 px-4 rounded-md max-w-[220px] fixed bottom-5 ltr:right-5 rtl:left-5 z-[99999]">
                  <span>Hello, world! This is a toast message.</span>
                </div>
              )}
                <button className="text-black transition-all duration-300 border rounded-md btn dark:text-white dark:hover:text-black border-light hover:bg-light hover:text-black" onClick={() => setToastLight(!toastLight)}>
                  light
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Notification;
